import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExcelExportButton = ({ data, fileName }) => {
  const exportToExcel = () => {
    // 1. Create a worksheet from JSON data
    const worksheet = XLSX.utils.json_to_sheet(data);

    // 2. Create a new empty workbook
    const workbook = XLSX.utils.book_new();

    // 3. Append the worksheet to the workbook with a sheet name
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DataSheet');

    // 4. Generate an Excel file buffer
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // 5. Create a Blob object with the correct Excel MIME type
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });

    // 6. Trigger file download using file-saver
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <button className="nav-link funds-btn dark-p-history" onClick={exportToExcel}>
      Excel
    </button>
  );
};

export default ExcelExportButton;